import {axiosInstanceToken} from "../../../../app/api";
import {
    IEducationsResponse,
    IOptionsResponse,
    ISaveEductionRequest
} from "../../../../interface/Passport/Education/backend";


export async function getEducations(): Promise<IEducationsResponse> {
    return axiosInstanceToken.get<IEducationsResponse>('/education').then(result => result.data)
}

export async function saveEducation(data: ISaveEductionRequest): Promise<undefined> {
    return axiosInstanceToken.put('/education', data).then(result => result.data)
}

export async function deleteEducation(id: number) {
    return axiosInstanceToken.delete('/education', {data: {id}}).then(result => result.data)
}

export async function getEducationInstitutionTypes(): Promise<IOptionsResponse> {
    return axiosInstanceToken.get<IOptionsResponse>('/education_institution_type').then(result => result.data)
}

export async function getCountries(): Promise<IOptionsResponse> {
    return axiosInstanceToken.get<IOptionsResponse>('/country').then(result => result.data)
}

export async function getCities(id: number): Promise<IOptionsResponse> {
    return axiosInstanceToken.get<IOptionsResponse>(`/country/${id}/city`).then(result => result.data)
}

export async function getEducationInstitutions(id: number): Promise<IOptionsResponse> {
    return axiosInstanceToken.get<IOptionsResponse>(`/city/${id}/education_institution`).then(result => result.data)
}